import { RedocStandalone } from 'redoc';
import { useNavigate } from 'react-router-dom';
import { Button, Box } from '@mui/material';

function ApiDocs() {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: 2 }}>
      <Button
        variant="outlined"
        color="primary"
        onClick={() => navigate('/dashboard')}
        sx={{ mb: 2 }}
      >
        Back to Dashboard
      </Button>

      <RedocStandalone
        specUrl="/assets/api_docs.yaml"
        options={{ scrollYOffset: 50 }}
      />
    </Box>
  );
}
export default ApiDocs;
